import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button, Form } from "react-bootstrap";
import { BASEAPIURL, token } from "../../env";

export default function RoomTypeTable() {
  const [roomTypes, setRoomTypes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
  const [facilityGroups, setFacilityGroups] = useState([]);
  const [sundryItems, setSundryItems] = useState([]);
  const [facilities, setFacilities] = useState([]);

  // Sundry modal state
  const [isSundryModalOpen, setIsSundryModalOpen] = useState(false);
  const [currentSundryIndex, setCurrentSundryIndex] = useState(-1);
  // Added RTSundry_ID to the sundryModalForm state structure
  const [sundryModalForm, setSundryModalForm] = useState({
    RTSundry_ID: 0, // Add this new field
    RTSundry_Name: "",
    RTSundry_Type: "",
    RTSundry_Optional: false,
    RTSundry_Amount: 0,
    RTSundry_EC_SundryID: 0,
    RTSundry_SundryID: 0,
    RTSundry_RTMainID: 0,
  });

  // Sundry list from API
  const [sundryList, setSundryList] = useState([]);
  const [sundryListLoading, setSundryListLoading] = useState(false);

  // Form state
  const [form, setForm] = useState({
    RoomType_ID: 0,
    RoomType: "",
    RoomType_Count: 0,
    FacilityGroupID: 0,
    FacilityID: 0,
    LocationID: 0,
    RoomPrice: 0,
    GuestRoomPrice: 0,
    MExtraBedPrice: 0,
    GExtraBedPrice: 0,
    TaxIsInclude: false,
    TaxPercentage: 0,
    EC_RoomType_ID: 0,
    From_Date: "",
    To_Date: "",
  });

  // Pricing form state
  const [pricingForm, setPricingForm] = useState({
    From_Date: "",
    RoomPrice: 0,
    GuestRoomPrice: 0,
    TaxPercentage: 0,
    TaxIsInclude: false,
    MemberExtraBedPrice: 0,
    GuestExtraBedPrice: 0,
  });

  const [filterDate, setFilterDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [pricingViewDate, setPricingViewDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const handleDateChange = (e) => {
    setFilterDate(e.target.value);
  };

  const fetchData = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const effectiveDate = filterDate;
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
      };
      const response = await fetch(
        `${BASEAPIURL}/GetRoomTypePricelist?Token=${token}&EffectiveDate=${effectiveDate}`,
        requestOptions
      );
      const result = await response.json();
      const data = Array.isArray(result)
        ? result
        : result?.data || result?.roomList || [];
      console.log({ result, data });

      const formatted = data.map((item) => ({
        RoomType_ID: Number(item.RoomType_ID) || 0,
        RoomType: String(item.RoomType || "").trim(),
        RoomType_Count: Math.max(Number(item.RoomType_Count) || 0, 0),
        FacilityGroupID: Number(item.FacilityGroupID) || 0,
        FacilityID: Number(item.FacilityID) || 0,
        LocationID: Number(item.LocationID) || 0,
        RoomPrice: Math.max(Number(item.MemberRoomPrice) || 0, 0),
        GuestRoomPrice: Math.max(Number(item.GuestRoomPrice) || 0, 0),
        MExtraBedPrice: Math.max(Number(item.MemberExtraBedPrice) || 0, 0),
        GExtraBedPrice: Math.max(Number(item.GuestExtraBedPrice) || 0, 0),
        TaxIsInclude: Boolean(item.TaxIsInclude),
        TaxPercentage: Math.max(Number(item.TaxPercentage) || 0, 0),
        EC_RoomType_ID: Number(item.EC_RoomType_ID) || 0,
        From_Date: item.From_Date || "",
        To_Date: item.To_Date || "",
        SundryID: item.SundryItems || [],
      }));
      setRoomTypes(formatted);
      if (formatted.length > 0) {
        setSundryItems(formatted[0].SundryID || []);
      }
    } catch (err) {
      console.error("Error fetching room types:", err);
      setError("Failed to load room types. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchLocations();
    fetchFacilityGroups();
    fetchFacilities(4);
  }, [filterDate]);

  const fetchLocations = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const raw = JSON.stringify({ tokenData: token });
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
      };
      const response = await fetch(
        `${BASEAPIURL}/LocationList`,
        requestOptions
      );
      const result = await response.json();
      const data = Array.isArray(result) ? result : result?.data || [];
      setLocations(data);
    } catch (err) {
      console.error("Error fetching locations:", err);
    }
  };

  const fetchFacilityGroups = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
      };
      const response = await fetch(
        `${BASEAPIURL}/GetFGrpListS?Token=${token}`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      let data = [];
      if (Array.isArray(result)) {
        data = result;
      } else if (result && typeof result === "object") {
        if (result.data && Array.isArray(result.data)) {
          data = result.data;
        } else if (
          result.FacilityGroups &&
          Array.isArray(result.FacilityGroups)
        ) {
          data = result.FacilityGroups;
        } else if (result.fgrplist && Array.isArray(result.fgrplist)) {
          data = result.fgrplist;
        } else if (
          result.facilityGroups &&
          Array.isArray(result.facilityGroups)
        ) {
          data = result.facilityGroups;
        } else {
          Object.values(result).forEach((value) => {
            if (Array.isArray(value)) {
              data = value;
              return;
            }
          });
        }
      }
      const processedData = data
        .map((item) => ({
          FacilityGroupID:
            Number(item.FacilityGroupID) || Number(item.FacilityGroup_Id) || 0,
          FacilityName: String(
            item.FacilityName || item.FacilityGroupName || item.Name || ""
          ),
        }))
        .filter((item) => item.FacilityGroupID > 0);
      setFacilityGroups(processedData);
    } catch (err) {
      console.error("Error fetching facility groups:", err);
      setFacilityGroups([]);
    }
  };

  const fetchSundryList = async () => {
    setSundryListLoading(true);
    try {
      const requestOptions = {
        method: "GET",
        redirect: "follow",
      };
      const response = await fetch(
        `${BASEAPIURL}/GetSundryList?Token=${token}`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      let data = [];
      if (Array.isArray(result)) {
        data = result;
      } else if (result && typeof result === "object") {
        if (result.data && Array.isArray(result.data)) {
          data = result.data;
        } else if (result.SundryList && Array.isArray(result.SundryList)) {
          data = result.SundryList;
        } else {
          Object.values(result).forEach((value) => {
            if (Array.isArray(value)) {
              data = value;
              return;
            }
          });
        }
      }
      setSundryList(data);
      console.log("Fetched Sundry List:", data); // Debug log
    } catch (error) {
      console.error("Error fetching sundry list:", error);
      setSundryList([]);
    } finally {
      setSundryListLoading(false);
    }
  };

  const mapSundryItems = (items) => {
    return items.map((item) => ({
      RTSundry_SundryID: item.RTSundry_SundryID || 0,
      RTSundry_EC_SundryID: item.RTSundry_EC_SundryID || 0,
      RTSundry_Name: item.RTSundry_Name || "",
      RTSundry_Type: item.RTSundry_Type || "",
      RTSundry_Amount: parseFloat(item.RTSundry_Amount) || 0,
      RTSundry_RTMainID: item.RTSundry_RTMainID || 0,
      RTSundry_Optional: Boolean(item.RTSundry_Optional),
      RTSundry_ID: item.RTSundry_ID || 0, // Ensure ID is mapped if available
    }));
  };

  const handleEdit = async (room) => {
    setForm({ ...room });
    setPricingViewDate(filterDate);
    await fetchSundryItems(room.RoomType_ID);
    setIsModalOpen(true);
  };

  const fetchSundryItems = async (roomTypeId) => {
    try {
      const url = `${BASEAPIURL}/GetSundrybyRoomtypeID?token=${token}&RoomtypeID=${roomTypeId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      let items = [];
      if (Array.isArray(result)) {
        items = result;
      } else if (result && typeof result === "object") {
        if (result.SundryItems && Array.isArray(result.SundryItems)) {
          items = result.SundryItems;
        } else if (result.data && Array.isArray(result.data)) {
          items = result.data;
        }
      }
      setSundryItems(mapSundryItems(items));
      console.log("Fetched Sundry Items:", items); // Debug log
    } catch (err) {
      console.error("Error fetching sundry items:", err);
      setSundryItems([]);
    }
  };

  const handlePricingViewDateChange = async (e) => {
    const date = e.target.value;
    setPricingViewDate(date);
    try {
      const response = await fetch(
        `${BASEAPIURL}/GetRoomTypePricelist?Token=${token}&EffectiveDate=${date}`
      );
      const result = await response.json();
      const data = Array.isArray(result)
        ? result
        : result?.data || result?.roomList || [];
      const roomItem = data.find(
        (item) => Number(item.RoomType_ID) === form.RoomType_ID
      );
      if (roomItem) {
        setForm((prev) => ({
          ...prev,
          RoomPrice: Math.max(Number(roomItem.MemberRoomPrice) || 0, 0),
          GuestRoomPrice: Math.max(Number(roomItem.GuestRoomPrice) || 0, 0),
          MExtraBedPrice: Math.max(
            Number(roomItem.MemberExtraBedPrice) || 0,
            0
          ),
          GExtraBedPrice: Math.max(Number(roomItem.GuestExtraBedPrice) || 0, 0),
          TaxIsInclude: Boolean(roomItem.TaxIsInclude),
          TaxPercentage: Math.max(Number(roomItem.TaxPercentage) || 0, 0),
          From_Date: date,
          To_Date: roomItem.To_Date || "",
        }));
        if (roomItem.SundryItems) {
          setSundryItems(mapSundryItems(roomItem.SundryItems));
        }
      } else {
        setForm((prev) => ({
          ...prev,
          From_Date: date,
          RoomPrice: 0,
          GuestRoomPrice: 0,
          MExtraBedPrice: 0,
          GExtraBedPrice: 0,
          TaxPercentage: 0,
          TaxIsInclude: false,
        }));
      }
    } catch (err) {
      console.error("Error fetching pricing for date:", err);
      setForm((prev) => ({ ...prev, From_Date: date }));
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let parsedValue;
    if (type === "checkbox") {
      parsedValue = checked;
    } else if (
      [
        "RoomType_ID",
        "RoomType_Count",
        "FacilityGroupID",
        "FacilityID",
        "LocationID",
        "RoomPrice",
        "GuestRoomPrice",
        "MExtraBedPrice",
        "GExtraBedPrice",
        "TaxPercentage",
        "EC_RoomType_ID",
      ].includes(name)
    ) {
      parsedValue = parseFloat(value) || 0;
    } else {
      parsedValue = value;
    }
    setForm((prev) => ({ ...prev, [name]: parsedValue }));
  };

  const handlePricingChange = (e) => {
    const { name, value, type, checked } = e.target;
    let parsedValue;
    if (type === "checkbox") {
      parsedValue = checked;
    } else if (
      [
        "RoomPrice",
        "GuestRoomPrice",
        "TaxPercentage",
        "MemberExtraBedPrice",
        "GuestExtraBedPrice",
      ].includes(name)
    ) {
      parsedValue = parseFloat(value) || 0;
    } else {
      parsedValue = value;
    }
    setPricingForm((prev) => ({ ...prev, [name]: parsedValue }));
  };

  const handleSundrySelection = (sundry) => {
    const selectedSundry = JSON.parse(sundry);
    if (selectedSundry) {
      setSundryModalForm((prev) => ({
        // Use functional update to ensure latest state
        ...prev,
        RTSundry_SundryID:
          selectedSundry.Sundry_ID || selectedSundry.SundryID || 0,
        RTSundry_EC_SundryID:
          selectedSundry.EC_SundryID || selectedSundry.SundryID || 0,
        RTSundry_Name:
          selectedSundry.RTSundry_Name || selectedSundry.Sundry_Name || "",
        RTSundry_Type:
          selectedSundry.RTSundry_Type || selectedSundry.Sundry_Type || "",
        RTSundry_Amount:
          parseFloat(selectedSundry.RTSundry_Amount || selectedSundry.Amount) ||
          0,
        RTSundry_Optional:
          Boolean(
            selectedSundry.RTSundry_Optional || selectedSundry.Optional
          ) || false,
        RTSundry_RTMainID: form.RoomType_ID || 0,
      }));
      console.log("Updated Sundry Modal Form:", {
        RTSundry_SundryID:
          selectedSundry.Sundry_ID || selectedSundry.SundryID || 0,
        RTSundry_EC_SundryID:
          selectedSundry.EC_SundryID || selectedSundry.SundryID || 0,
        RTSundry_Name:
          selectedSundry.RTSundry_Name || selectedSundry.Sundry_Name || "",
        RTSundry_Type:
          selectedSundry.RTSundry_Type || selectedSundry.Sundry_Type || "",
        RTSundry_Amount:
          parseFloat(selectedSundry.RTSundry_Amount || selectedSundry.Amount) ||
          0,
        RTSundry_Optional:
          Boolean(
            selectedSundry.RTSundry_Optional || selectedSundry.Optional
          ) || false,
        RTSundry_RTMainID: form.RoomType_ID || 0,
      }); // Debug log
    } else {
      setSundryModalForm((prev) => ({
        // Use functional update
        ...prev,
        RTSundry_SundryID: 0,
        RTSundry_EC_SundryID: 0,
        RTSundry_Name: "",
        RTSundry_Type: "",
        RTSundry_Amount: 0,
        RTSundry_Optional: false,
        RTSundry_RTMainID: form.RoomType_ID || 0,
      }));
      console.log("Reset Sundry Modal Form"); // Debug log
    }
  };

  const handleSundryModalChange = (e) => {
    const { name, value, type, checked } = e.target;
    let parsedValue;
    if (type === "checkbox") {
      parsedValue = checked;
    } else if (name === "RTSundry_Amount") {
      parsedValue = parseFloat(value) || 0;
    } else {
      parsedValue = value;
    }
    setSundryModalForm((prev) => ({
      ...prev,
      [name]: parsedValue,
    }));
    console.log("Sundry Modal Form Change:", { [name]: parsedValue }); // Debug log
  };

  const openAddSundryModal = () => {
    fetchSundryList();
    setSundryModalForm({
      RTSundry_ID: 0, // Reset ID for adding new
      RTSundry_Name: sundryModalForm.RTSundry_Name,
      RTSundry_Type: sundryModalForm.RTSundry_Type,
      RTSundry_Optional: Boolean(
        sundryModalForm.RTSundry_Optional || sundryModalForm.Optional
      ),
      RTSundry_Amount: parseFloat(
        sundryModalForm.RTSundry_Amount || sundryModalForm.Amount
      ),
      RTSundry_EC_SundryID: sundryModalForm.EC_SundryID,
      RTSundry_SundryID: sundryModalForm.Sundry_ID,
      RTSundry_RTMainID: form.RoomType_ID,
    });
    setCurrentSundryIndex(-1);
    setIsSundryModalOpen(true);
  };

  // Updated saveSundry function to use UpdateRoomTypeSundry API when editing
  const saveSundry = async () => {
    // Validation (you can add more specific checks if needed)
    if (!sundryModalForm.RTSundry_Name.trim()) {
      alert("Please select or enter a sundry name");
      return;
    }
    if (!sundryModalForm.RTSundry_Type.trim()) {
      alert("Please enter a type name");
      return;
    }
    if (sundryModalForm.RTSundry_Amount < 0) {
      alert("Amount cannot be negative");
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Determine the API endpoint and payload structure based on whether it's an update or insert
    let url, rawPayload, method;

    if (sundryModalForm.RTSundry_ID > 0) {
      // If RTSundry_ID exists, it's an update
      url = `${BASEAPIURL}/UpdateRoomTypeSundry`; // Use the update API
      method = "POST";
      rawPayload = JSON.stringify({
        token: token,
        RoomTypeSundry: [
          {
            RTSundry_ID: sundryModalForm.RTSundry_ID, // Include the ID for update
            RTSundry_SundryID: sundryModalForm.RTSundry_SundryID || 0,
            RTSundry_EC_SundryID: sundryModalForm.RTSundry_EC_SundryID || 0,
            RTSundry_Name: sundryModalForm.RTSundry_Name || "",
            RTSundry_Type: sundryModalForm.RTSundry_Type || "",
            RTSundry_Amount: sundryModalForm.RTSundry_Amount || 0,
            RTSundry_RTMainID: sundryModalForm.RTSundry_RTMainID || 0,
            RTSundry_Optional: sundryModalForm.RTSundry_Optional ?? false,
            // Assuming default values for potentially missing fields in update payload
            RTSundry_TaxPercentage: 0.0, // Add default or use state if available
            IsTaxInclud: false, // Add default or use state if available
          },
        ],
      });
    } else {
      // If RTSundry_ID does not exist or is 0, it's an insert
      url = `${BASEAPIURL}/InsertRoomTypeSundry`; // Use the insert API
      method = "POST";
      rawPayload = JSON.stringify({
        token: token,
        RoomTypeSundry: [
          {
            // Note: RTSundry_ID is typically auto-generated on the server for inserts,
            // so it's not included in the payload for InsertRoomTypeSundry.
            RTSundry_SundryID: sundryModalForm.RTSundry_SundryID || 0,
            RTSundry_EC_SundryID: sundryModalForm.RTSundry_EC_SundryID || 0,
            RTSundry_Name: sundryModalForm.RTSundry_Name || "",
            RTSundry_Type: sundryModalForm.RTSundry_Type || "",
            RTSundry_Amount: sundryModalForm.RTSundry_Amount || 0,
            RTSundry_RTMainID: sundryModalForm.RTSundry_RTMainID || 0,
            RTSundry_Optional: sundryModalForm.RTSundry_Optional ?? false,
            RTSundry_TaxPercentage: 0.0, // Add default or use state if available
            IsTaxInclud: false, // Add default or use state if available
          },
        ],
      });
    }

    const requestOptions = {
      method: method,
      headers: myHeaders,
      body: rawPayload,
      redirect: "follow",
    };

    try {
      const response = await fetch(url, requestOptions);
      const result = await response.text();
      console.log(`${method === "POST" ? "Save" : "Update"} Response:`, result);

      if (response.ok) {
        alert(
          `Sundry item ${sundryModalForm.RTSundry_ID > 0 ? "updated" : "added"
          } successfully!`
        );
        // Close modal and refresh sundry items list in the main modal
        setIsSundryModalOpen(false);
        // Refetch sundry items for the current room type to reflect the change
        await fetchSundryItems(form.RoomType_ID);
        // Reset the sundry modal form after successful save/update
        setSundryModalForm({
          RTSundry_ID: 0, // Reset ID for next operation
          RTSundry_Name: "",
          RTSundry_Type: "",
          RTSundry_Optional: false,
          RTSundry_Amount: 0,
          RTSundry_EC_SundryID: 0,
          RTSundry_SundryID: 0,
          RTSundry_RTMainID: form.RoomType_ID,
        });
      } else {
        console.error(`API Error: ${response.status} - ${response.statusText}`);
        alert(
          `Failed to ${sundryModalForm.RTSundry_ID > 0 ? "update" : "add"
          } sundry item. Check console for details.`
        );
      }
    } catch (error) {
      console.error(
        `Error ${sundryModalForm.RTSundry_ID > 0 ? "updating" : "saving"
        } sundry:`,
        error
      );
      alert(
        `Network error. Failed to ${sundryModalForm.RTSundry_ID > 0 ? "update" : "add"
        } sundry item.`
      );
    }
  };

  const openEditSundryModal = (item, index) => {
    fetchSundryList();
    setSundryModalForm({
      RTSundry_ID: item.RTSundry_ID || 0, // Set the ID for updating
      RTSundry_Name: item.RTSundry_Name || "",
      RTSundry_Type: item.RTSundry_Type || "",
      RTSundry_Optional: Boolean(item.RTSundry_Optional),
      RTSundry_Amount: parseFloat(item.RTSundry_Amount) || 0,
      RTSundry_EC_SundryID: item.RTSundry_EC_SundryID || 0,
      RTSundry_SundryID: item.RTSundry_SundryID || 0,
      RTSundry_RTMainID: item.RTSundry_RTMainID || form.RoomType_ID,
    });
    setCurrentSundryIndex(index);
    setIsSundryModalOpen(true);
  };

  const handleSaveSundry = () => {
    if (!sundryModalForm.RTSundry_Name.trim()) {
      alert("Please select or enter a sundry name");
      return;
    }
    if (!sundryModalForm.RTSundry_Type.trim()) {
      alert("Please enter a type name");
      return;
    }
    if (sundryModalForm.RTSundry_Amount < 0) {
      alert("Amount cannot be negative");
      return;
    }
    const newItem = { ...sundryModalForm };
    const isDuplicate = sundryItems.some(
      (item, index) =>
        item.RTSundry_EC_SundryID === newItem.RTSundry_EC_SundryID &&
        index !== currentSundryIndex
    );
    if (isDuplicate) {
      alert("This sundry item is already added.");
      return;
    }
    if (currentSundryIndex === -1) {
      setSundryItems((prev) => [...prev, { ...newItem, RTSundry_SundryID: 0 }]);
    } else {
      setSundryItems((prev) =>
        prev.map((item, index) =>
          index === currentSundryIndex ? newItem : item
        )
      );
    }
    console.log("Saved Sundry Items:", sundryItems); // Debug log
    setIsSundryModalOpen(false);
    setSundryModalForm({
      RTSundry_Name: "",
      RTSundry_Type: "",
      RTSundry_Optional: false,
      RTSundry_Amount: 0,
      RTSundry_EC_SundryID: 0,
      RTSundry_SundryID: 0,
      RTSundry_RTMainID: form.RoomType_ID,
    });
  };

  const removeSundryItem = (index) => {
    if (window.confirm("Are you sure you want to delete this sundry item?")) {
      setSundryItems((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const handleSubmit = async () => {
    if (
      !form.RoomType.trim() ||
      // form.RoomType_Count < 1 ||
      // form.FacilityGroupID < 1 ||
      // form.FacilityID < 1 ||
      // form.LocationID < 1 ||
      form.RoomPrice < 0
    ) {
      alert("Please fill all required fields with valid values.");
      return;
    }
    const payload = {
      tokenData: token,
      RType: {
        RoomType_ID: form.RoomType_ID,
        RoomType: form.RoomType.trim(),
        RoomType_Count: form.RoomType_Count,
        FacilityGroupID: form.FacilityGroupID,
        FacilityID: form.FacilityID,
        LocationID: form.LocationID,
        MemberRoomPrice: form.RoomPrice,
        GuestRoomPrice: form.GuestRoomPrice,
        MemberExtraBedPrice: form.MExtraBedPrice,
        GuestExtraBedPrice: form.GExtraBedPrice,
        TaxIsInclude: form.TaxIsInclude,
        TaxPercentage: form.TaxPercentage,
        EC_RoomType_ID: form.EC_RoomType_ID,
        From_Date: form.From_Date,
        To_Date: form.To_Date,
        SundryID: sundryItems,
      },
    };
    try {
      const url = `${BASEAPIURL}/UpdateRoomType?MainID=${form.RoomType_ID}`;
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      console.log("Update response:", result);
      if (result.Status === true) {
        alert("Room type updated successfully!");
        setIsModalOpen(false);
        fetchData();
      } else {
        alert(result.message || "Update failed. Please try again.");
      }
    } catch (err) {
      console.error("Update error:", err);
      alert("Network error. Failed to update room type.");
    }
  };

  const handleAddPricing = () => {
    setPricingForm({
      From_Date: "",
      RoomPrice: 0,
      GuestRoomPrice: 0,
      TaxPercentage: 0,
      TaxIsInclude: false,
      MemberExtraBedPrice: 0,
      GuestExtraBedPrice: 0,
    });
    setIsPricingModalOpen(true);
  };

  const handleEditPricing = () => {
    setPricingForm({
      From_Date: form.From_Date || "",
      RoomPrice: form.RoomPrice,
      GuestRoomPrice: form.GuestRoomPrice,
      TaxPercentage: form.TaxPercentage,
      TaxIsInclude: form.TaxIsInclude,
      MemberExtraBedPrice: form.MExtraBedPrice,
      GuestExtraBedPrice: form.GExtraBedPrice,
    });
    setIsPricingModalOpen(true);
  };

  const handleSavePricing = async () => {
    if (!pricingForm.From_Date || pricingForm.RoomPrice < 0) {
      alert("Please fill all required fields with valid values.");
      return;
    }
    const pricingPayload = {
      token: token,
      RoomTypeDtl: {
        RoomTypeDtl_MainID: form.RoomType_ID,
        EffectiveDate: pricingForm.From_Date,
        MemberRate: pricingForm.RoomPrice,
        GuestRate: pricingForm.GuestRoomPrice,
        MemberExtraBed: pricingForm.MemberExtraBedPrice,
        GuestExtraBed: pricingForm.GuestExtraBedPrice,
        TaxPercentage: pricingForm.TaxPercentage,
        EC_RoomType_ID: form.EC_RoomType_ID,
        Is_TaxInclude: pricingForm.TaxIsInclude,
      },
    };
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(pricingPayload),
        redirect: "follow",
      };
      const response = await fetch(
        `${BASEAPIURL}/InsertRoomTypeDtl`,
        requestOptions
      );
      const result = await response.text();
      console.log("Pricing insert response:", result);
      if (response.ok) {
        alert("Pricing details saved successfully!");
        setForm((prev) => ({
          ...prev,
          RoomPrice: pricingForm.RoomPrice,
          GuestRoomPrice: pricingForm.GuestRoomPrice,
          TaxPercentage: pricingForm.TaxPercentage,
          TaxIsInclude: pricingForm.TaxIsInclude,
          From_Date: pricingForm.From_Date,
          To_Date: pricingForm.To_Date,
          MExtraBedPrice: pricingForm.MemberExtraBedPrice,
          GExtraBedPrice: pricingForm.GuestExtraBedPrice,
        }));
        setIsPricingModalOpen(false);
        setPricingViewDate(pricingForm.From_Date);
        await handlePricingViewDateChange({
          target: { value: pricingForm.From_Date },
        });
        fetchData();
      } else {
        alert("Failed to save pricing details. Please try again.");
      }
    } catch (error) {
      console.error("Error saving pricing:", error);
      alert("Network error. Failed to save pricing details.");
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closePricingModal = () => {
    setIsPricingModalOpen(false);
  };

  const closeSundryModal = () => {
    setIsSundryModalOpen(false);
    setSundryModalForm({
      RTSundry_Name: "",
      RTSundry_Type: "",
      RTSundry_Optional: false,
      RTSundry_Amount: 0,
      RTSundry_EC_SundryID: 0,
      RTSundry_SundryID: 0,
      RTSundry_RTMainID: form.RoomType_ID,
    });
  };

  const fetchFacilities = async (groupId) => {
    if (groupId > 0) {
      try {
        const response = await fetch(
          `${BASEAPIURL}/GetFacilityUIByFGrpID?FGrpID=${groupId}&Token=${token}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            redirect: "follow",
          }
        );
        const data = await response.json();
        const list = Array.isArray(data) ? data : data?.data || [];
        setFacilities(list);
      } catch (err) {
        console.error("Error fetching facilities:", err);
        setFacilities([]);
      }
    } else {
      setFacilities([]);
    }
  };

  if (loading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 text-muted">Loading room types...</p>
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger text-center m-4">{error}</div>;
  }

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="text-dark mb-0">🏨 Room Types</h3>
        <div className="d-flex align-items-center">
          <label htmlFor="filterDate" className="me-2 mb-0">
            Filter by Date:
          </label>
          <input
            type="date"
            id="filterDate"
            value={filterDate}
            onChange={handleDateChange}
            className="form-control"
            style={{ width: "180px" }}
            min="1000-01-01"
            max="9999-12-31"
          />
          <button
            className="btn btn-sm btn-outline-secondary ms-2"
            onClick={fetchData}
          >
            Apply Filter
          </button>
        </div>
      </div>
      <div className="card shadow-sm border-0">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Room Type</th>
                  <th>Available Rooms</th>
                  <th>Price (₹)</th>
                  <th>Guest Price</th>
                  <th>Member Extra Bed</th>
                  <th>Guest Extra Bed</th>
                  <th>Tax Percentage</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {roomTypes.length > 0 ? (
                  roomTypes.map((room, index) => (
                    <tr key={room.RoomType_ID}>
                      <td>{index + 1}</td>
                      <td>
                        <strong>{room.RoomType}</strong>
                      </td>
                      <td>
                        <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-1 rounded-pill">
                          {room.RoomType_Count}
                        </span>
                      </td>
                      <td>
                        <strong className="text-success">
                          ₹{room.RoomPrice.toFixed(2)}
                        </strong>
                      </td>
                      <td>₹{room.GuestRoomPrice.toFixed(2)}</td>
                      <td>₹{room.MExtraBedPrice.toFixed(2)}</td>
                      <td>₹{room.GExtraBedPrice.toFixed(2)}</td>
                      <td>{room.TaxPercentage.toFixed(2)}%</td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleEdit(room)}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-muted py-4">
                      No room types available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal
        show={isModalOpen}
        className="w-100"
        onHide={closeModal}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header className="bg-warning text-dark">
          <Modal.Title size="h4">✏️ Edit Room Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-3 mb-3">
            <div className="col-md-4">
              <label>Room Type</label>
              <input
                type="text"
                name="RoomType"
                value={form.RoomType}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
            <div className="col-md-4">
              <label>Location</label>
              <select
                name="LocationID"
                value={form.LocationID}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value="">Select Location</option>
                {locations.map((loc) => (
                  <option key={loc.LocID} value={loc.LocID}>
                    {loc.LocName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <label>Available Rooms</label>
              <input
                type="number"
                name="RoomType_Count"
                value={form.RoomType_Count}
                onChange={handleChange}
                min="1"
                className="form-control"
                required
              />
            </div>
            {/* <div className="col-md-4">
              <label>EC Room type ID</label>
              <input
                type="number"
                name="EC_RoomType_ID"
                value={form.EC_RoomType_ID}
                onChange={handleChange}
                min="1"
                className="form-control"
                required
              />
            </div> */}
          </div>
          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <label>Facility Group</label>
              {/* <select
                name="FacilityGroupID"
                value={form.FacilityGroupID}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value="">Select Facility Group</option>
                {facilityGroups.map((group) => (
                  <option key={group.FacilityGroupID} value={group.FacilityGroupID}>
                    {group.FacilityName}
                  </option>
                ))}
              </select> */}
              <input
                name="GroupFacility"
                value={"Rooms"}
                className="form-control"
                required
              />
            </div>
            <div className="col-md-6">
              <label>Facility</label>
              <select
                name="FacilityID"
                value={form.FacilityID}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value="">Select Facility</option>
                {facilities.map((fac) => (
                  <option key={fac.Facility_ID} value={fac.Facility_ID}>
                    {fac.Facility_Name || `Facility ${fac.Facility_ID}`}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="text-dark mb-0">🏨 Pricing Information</h5>
              <button
                className="btn btn-sm btn-outline-info"
                onClick={handleAddPricing}
              >
                <i className="fas fa-plus"></i> Add
              </button>
            </div>
            <table className="table table-bordered table-sm mb-0">
              <thead>
                <tr>
                  <th>Effective Date</th>
                  <th>Member Price</th>
                  <th>Guest Price</th>
                  <th>Member Extra Bed</th>
                  <th>Guest Extra Bed</th>
                  <th>Tax %</th>
                  <th>Tax Inc.</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="date"
                      name="From_Date"
                      value={pricingViewDate}
                      onChange={handlePricingViewDateChange}
                      className="form-control"
                      style={{
                        backgroundColor: "#f8f9fa",
                        color: "black",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        padding: "6px",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      step="1.00"
                      name="RoomPrice"
                      value={form.RoomPrice}
                      onChange={handleChange}
                      min="0"
                      className="form-control"
                      readOnly
                      style={{
                        backgroundColor: "#f8f9fa",
                        color: "black",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        padding: "6px",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      step="1.00"
                      name="GuestRoomPrice"
                      value={form.GuestRoomPrice}
                      onChange={handleChange}
                      min="0"
                      className="form-control"
                      readOnly
                      style={{
                        backgroundColor: "#f8f9fa",
                        color: "black",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        padding: "6px",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      step="1.00"
                      name="MExtraBedPrice"
                      value={form.MExtraBedPrice}
                      onChange={handleChange}
                      min="0"
                      className="form-control"
                      readOnly
                      style={{
                        backgroundColor: "#f8f9fa",
                        color: "black",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        padding: "6px",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      step="1.00"
                      name="GExtraBedPrice"
                      value={form.GExtraBedPrice}
                      onChange={handleChange}
                      min="0"
                      className="form-control"
                      readOnly
                      style={{
                        backgroundColor: "#f8f9fa",
                        color: "black",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        padding: "6px",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      step="1.00"
                      name="TaxPercentage"
                      value={form.TaxPercentage}
                      onChange={handleChange}
                      min="0"
                      max="100"
                      className="form-control"
                      readOnly
                      style={{
                        backgroundColor: "#f8f9fa",
                        color: "black",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        padding: "6px",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      name="TaxIsInclude"
                      checked={form.TaxIsInclude}
                      onChange={handleChange}
                      disabled
                      className="form-check-input"
                      style={{ width: "auto", height: "auto" }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="text-dark mb-0">🧾 Sundry Information</h5>
              <button
                className="btn btn-sm btn-outline-success"
                onClick={openAddSundryModal}
              >
                <i className="fas fa-plus"></i> Add Sundry
              </button>
            </div>
            {sundryItems.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Sundry Name</th>
                      <th>Type</th>
                      <th>Optional</th>
                      <th>Amount</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sundryItems.map((item, index) => (
                      <tr key={index}>
                        <td>{item.RTSundry_Name || "N/A"}</td>
                        <td>{item.RTSundry_Type || "N/A"}</td>
                        <td>
                          {item.RTSundry_Optional
                            ? "Non-Mandatory"
                            : "Mandatory"}
                        </td>
                        <td>
                          ₹{parseFloat(item.RTSundry_Amount || 0).toFixed(2)}
                        </td>
                        <td className="text-center align-middle">
                          <div className="d-flex gap-1 justify-content-center">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => openEditSundryModal(item, index)}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => removeSundryItem(index)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center text-muted py-3">
                No sundry items added. Click "Add Sundry" to add one.
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button variant="warning" onClick={handleSubmit}>
            Update Room Type
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isSundryModalOpen}
        onHide={closeSundryModal}
        size="md"
        centered
        backdrop="static"
      >
        <Modal.Header
          className={
            currentSundryIndex === -1
              ? "bg-success text-white"
              : "bg-primary text-white"
          }
        >
          <Modal.Title>
            {currentSundryIndex === -1
              ? "➕ Add Sundry Item"
              : "✏️ Edit Sundry Item"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="mb-3">
              <Form.Label>
                Select Sundry <span className="text-danger">*</span>
              </Form.Label>
              {sundryListLoading ? (
                <div className="text-center">
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <small className="text-muted d-block mt-1">
                    Loading sundry items...
                  </small>
                </div>
              ) : (
                <Form.Select
                  name="RTSundry_EC_SundryID"
                  value={sundryModalForm.RTSundry_SundryID || 0}
                  onChange={(e) => handleSundrySelection(e.target.value)}
                  required
                >
                  <option value={0}>Select a sundry item</option>
                  {sundryList.map((sundry) => (
                    <option
                      key={sundry.RTSundry_EC_SundryID}
                      value={JSON.stringify(sundry)}
                    >
                      {sundry.RTSundry_Name ||
                        sundry.Sundry_Name ||
                        "Unnamed Sundry"}
                    </option>
                  ))}
                </Form.Select>
              )}
            </div>
            <div className="mb-3">
              <Form.Label>
                Sundry Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="RTSundry_Name"
                value={sundryModalForm.RTSundry_Name || ""}
                onChange={handleSundryModalChange}
                placeholder="Sundry name will be auto-filled"
                required
                readOnly={sundryModalForm.RTSundry_EC_SundryID > 0}
              />
            </div>
            <div className="mb-3">
              <Form.Label>
                Type Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="RTSundry_Type"
                value={sundryModalForm.RTSundry_Type || ""}
                onChange={handleSundryModalChange}
                placeholder="Type name will be auto-filled"
                required
                readOnly={sundryModalForm.RTSundry_EC_SundryID > 0}
              />
            </div>
            <div className="mb-3">
              <Form.Label>Optional</Form.Label>
              <Form.Select
                name="RTSundry_Optional"
                value={
                  sundryModalForm.RTSundry_Optional
                    ? "Non-Mandatory"
                    : "Mandatory"
                }
                onChange={(e) => {
                  const isOptional = e.target.value === "Non-Mandatory";
                  setSundryModalForm((prev) => ({
                    ...prev,
                    RTSundry_Optional: isOptional,
                  }));
                }}
              >
                <option value="Additive">Additive</option>
                <option value="Subtractive">Subtractive</option>
              </Form.Select>
            </div>
            <div className="mb-3">
              <Form.Label>
                Amount <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                name="RTSundry_Amount"
                value={sundryModalForm.RTSundry_Amount || 0}
                onChange={handleSundryModalChange}
                min="0"
                step="0.01"
                placeholder="0.00"
                required
              />
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeSundryModal}>
            Cancel
          </Button>
          <Button
            variant={currentSundryIndex === -1 ? "success" : "primary"}
            onClick={saveSundry} // Use the updated saveSundry function
            disabled={sundryListLoading}
          >
            {currentSundryIndex === -1 ? "Add Sundry" : "Update Sundry"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isPricingModalOpen}
        onHide={closePricingModal}
        size="md"
        centered
        backdrop="static"
      >
        <Modal.Header className="bg-info text-white">
          <Modal.Title>📋 Pricing Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <label>From Date</label>
              <input
                type="date"
                name="From_Date"
                value={pricingForm.From_Date}
                onChange={handlePricingChange}
                className="form-control"
                min="1000-01-01"
                max="9999-12-31"

              />
            </div>
            <div className="col-md-6">
              <label>Tax Percentage</label>
              <input
                type="number"
                step="1.00"
                name="TaxPercentage"
                value={pricingForm.TaxPercentage}
                onChange={handlePricingChange}
                min="0"
                max="100"
                className="form-control"
              />
            </div>
          </div>
          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <label>Member Price</label>
              <input
                type="number"
                step="1.00"
                name="RoomPrice"
                value={pricingForm.RoomPrice}
                onChange={handlePricingChange}
                min="0"
                className="form-control"
              />
            </div>
            <div className="col-md-6">
              <label>Guest Room Price</label>
              <input
                type="number"
                step="1.00"
                name="GuestRoomPrice"
                value={pricingForm.GuestRoomPrice}
                onChange={handlePricingChange}
                min="0"
                className="form-control"
              />
            </div>
          </div>
          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <label>Member Extra Bed Price</label>
              <input
                type="number"
                step="1.00"
                name="MemberExtraBedPrice"
                value={pricingForm.MemberExtraBedPrice}
                onChange={handlePricingChange}
                min="0"
                className="form-control"
              />
            </div>
            <div className="col-md-6">
              <label>Guest Extra Bed Price</label>
              <input
                type="number"
                step="1.00"
                name="GuestExtraBedPrice"
                value={pricingForm.GuestExtraBedPrice}
                onChange={handlePricingChange}
                min="0"
                className="form-control"
              />
            </div>
          </div>
          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <div className="form-check mt-4">
                <input
                  type="checkbox"
                  name="TaxIsInclude"
                  checked={pricingForm.TaxIsInclude}
                  onChange={handlePricingChange}
                  className="form-check-input"
                />
                <label className="form-check-label ms-2">
                  Tax Included in Price
                </label>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closePricingModal}>
            Cancel
          </Button>
          <Button variant="info" onClick={handleSavePricing}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
